module.exports = __webpack_public_path__ + "img/gift.2902915e.png";